import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { format } from 'date-fns';

import { Button, Select } from '../../../components';

const DURATION_OPTIONS = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];

export default class TemplateItemModal extends React.Component {
	static propTypes = {
		isOpen: PropTypes.bool.isRequired,
		appointment: PropTypes.object,
		onAdd: PropTypes.func.isRequired,
		onCancel: PropTypes.func.isRequired,
		timezone: PropTypes.string,
	};

	static defaultProps = {
		isOpen: false,
	};

	state = {
		startDate: '',
		durationInMinutes: 30,
		isAdding: false,
	};

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (nextProps.appointment && nextProps.appointment.startDate) {
			this.setState({
				startDate: format(
					nextProps.appointment.startDate,
					"yyyy-MM-dd'T'HH:mm"
				),
				isAdding: false,
			});
		}
	}

	handleAdd = () => {
		const { startDate, durationInMinutes } = this.state;
		this.setState({ isAdding: true });
		this.props.onAdd(startDate, durationInMinutes);
	};

	handleStartDateChange = ({ target }) => {
		this.setState({ startDate: target.value });
	};

	handleDurationChange = ({ target }) => {
		this.setState({ durationInMinutes: parseInt(target.value, 10) });
	};

	render() {
		const { isOpen, onCancel } = this.props;
		const { isAdding, startDate, durationInMinutes } = this.state;
		return (
			<Modal
				isOpen={isOpen}
				contentLabel="Add Appointment Slot"
				className="modal-dialog"
			>
				<div className="modal-content">
					<div className="modal-header">
						<div className="clearfix">
							<div className="pull-right">
								<button className="btn btn-link" onClick={onCancel}>
									<em className="fa fa-lg fa-times" />
								</button>
							</div>
							<h3 className="modal-title">
								Add Appointment Slot{' '}
								<small>Choose the start time and duration.</small>
							</h3>
						</div>
					</div>
					<div className="modal-body form">
						<div className="form-group">
							<label>Start at</label>
							<input
								type="datetime-local"
								className="form-control"
								value={startDate}
								onChange={this.handleStartDateChange}
							/>
						</div>
						<div className="form-group">
							<label>Duration (in minutes)</label>
							<Select
								options={DURATION_OPTIONS}
								selectedValue={durationInMinutes}
								onChange={this.handleDurationChange}
							/>
						</div>
					</div>
					<div className="modal-footer">
						<div className="pull-right">
							<Button
								title="Cancel"
								large
								onClick={onCancel}
								disabled={isAdding}
							/>
							<Button
								title="Save"
								onClick={this.handleAdd}
								disabled={isAdding}
								large
								primary
								className="ml"
							/>
						</div>
					</div>
				</div>
			</Modal>
		);
	}
}
